import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReviewBlue = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "20px",
	viewBox: "0 0 512 512",
	width: "20px",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		d: "m256 0c-141.480469 0-256 114.496094-256 256v256h256c141.480469 0 256-114.496094 256-256 0-141.480469-114.496094-256-256-256zm105.054688 415.042969-105.054688-40.09375-105.054688 40.089843 5.664063-112.300781-70.589844-87.523437 108.554688-29.316406 61.425781-94.183594 61.425781 94.183594 108.558594 29.316406-70.59375 87.523437zm0 0",
		className: "active-path",
		fill: "#009688"
	}) })
});
export default SvgReviewBlue;
